<script>
import {ref, onMounted} from "vue";
import axios from "axios";

export default {

  props: {
    accessToken: String,
    count: Number,
    pagination: Boolean,
    caption: Boolean,
  },
  data() {
    return {
      isLoading: true,
      hasError: false,
      instagramData: null,
      usePagination: false,
      showCaption: false,
      paginationNextUrl: "",
      paginationPrevUrl: ""
    }
  },
  computed: {},
  ready: function () {
  },
  methods: {
    fetchInstaData(url) {
      axios
          .get(url)
          .then((response) => {
            if (response.hasOwnProperty("error")) {
              this.isLoading.value = false;
              this.hasError.value = true;
            } else {
              this.instagramData = response.data;
              if (this.instagramData.data !== null) {
                this.isLoading = false;
              }
            }
          })
          .then(() => {
            if (this.pagination) {
              this.usePagination = this.pagination;
            }
            if (this.caption) {
              this.showCaption = this.caption;
            }
          })
          .catch((error) => {
            console.log("Error:", error);
            this.hasError = true;
            this.isLoading = false;
          });
    },

    handlePaginationNext() {
      this.fetchInstaData(this.paginationNextUrl.value);
    },
    handlePaginationPrev() {
      this.fetchInstaData(this.paginationPrevUrl.value);
    },
  },
  mounted() {
    const url = `https://graph.instagram.com/me/media?fields=media_count,media_type,permalink,media_url,caption&limit=${this.count}&access_token=${this.accessToken}`;
    this.fetchInstaData(url);
  },
}

</script>

<template>
  <div class="instagram-wrapper">
    <h3 v-if="this.isLoading">LOADING...</h3>
    <h3 v-else-if="this.hasError">Ooops, something went wrong.</h3>
    <div v-else-if="instagramData.data != null" class="instagram-gallery">
      <div class="container">
        <div class="row gy-3">
          <div v-for="image in instagramData.data" :key="image.id" class="col col-lg-3 instagram-gallery-item">
            <a :href="image.permalink" :key="image.id" target="_blank" rel="d-flex noreferrer">
            <div class="card">
                <div v-if="image.media_type === 'IMAGE' || image.media_type === 'CAROUSEL_ALBUM'" class="ratio ratio-1x1 overflow-hidden">
                  <img  :src="image.media_url" :alt="image.caption" :key="image.id" class="card-img-top w-auto h-100"/>
                </div>
                <video v-else :key="image.id" class="instagram-gallery-image">
                  <source :src="image.media_url" type="video/mp4"/>
                </video>
              <div class="card-body">
                <p v-if="showCaption" class="card-text">{{ image.caption }}</p>
              </div>
              <span class="icon"><i class="fab fa-instagram"></i></span> <span class="readtime"></span>
            </div>
            </a>
          </div>
          <!--          <div v-if="usePagination">-->
          <!--            <div v-if="paginationPrevUrl">-->
          <!--              <button class="" type="button" @click="handlePaginationPrev">-->
          <!--                Previous-->
          <!--              </button>-->
          <!--            </div>-->
          <!--            <div v-if="paginationNextUrl">-->
          <!--              <button class="" type="button" @click="handlePaginationNext">-->
          <!--                Next-->
          <!--              </button>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.instagram-wrapper .icon { position: absolute; right: 15px; top: 15px; opacity: 0.5; color: black;}
.instagram-wrapper .icon  i {font-size: 2rem;}
.instagram-gallery-item:hover .icon {
  opacity: 1; background: -moz-radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);;
  background: -webkit-radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);;
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);;
  -webkit-background-clip: text;
  -moz-background-clip: text; 
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.card-text { font-size: 1rem; display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;overflow: hidden;}

</style>